import { useEffect, useId, useState } from 'react';
import { countries, countryName } from '../../../../shared/countries.ts';
const ukrainianNames = new Intl.DisplayNames(['uk'], {type:'region'});

export function CountrySearch({id,label,value,onChange,disabled=false}:{id?:string;label:string;value:string;onChange:(code:string)=>void;disabled?:boolean}) {
  const generated=useId(),inputId=id ?? generated;
  const [query,setQuery]=useState(value?countryName(value):'');
  useEffect(()=>{if(value)setQuery(countryName(value));},[value]);
  return <><label htmlFor={inputId}>{label}
    <input id={inputId} className="input" list={inputId+'-countries'} value={query} disabled={disabled} placeholder="Введіть назву країни" autoComplete="off"
      onChange={e=>{const text=e.target.value;setQuery(text);const match=countries.find(country=>[country.name,country.code,ukrainianNames.of(country.code)].some(name=>name?.toLowerCase()===text.trim().toLowerCase()));onChange(match?.code ?? '');}}/>
  </label>
    <datalist id={inputId+'-countries'}>{countries.map(country=><option key={country.code} value={country.name}>{ukrainianNames.of(country.code)} · {country.code}</option>)}</datalist>
  </>;
}
